export function adaptPlainObjectToCamelCase<T>(objs: T[]): T[] {
  return objs.map(obj => {
    return Object.entries(obj).reduce((acc, entry) => {
      const key = entry[0];
      const pascalKey = key.substring(0, 1).toLowerCase() + key.substring(1, key.length);
      acc[pascalKey] = entry[1];
      return acc;
    }, {} as T);
  });
}
